import React from 'react'
import { useInView } from 'react-intersection-observer'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { Badges } from './Badges'
import { ImageBox } from './styles'

interface Props {
  game: GameWithUserInformation
  forceInView?: boolean
  onClick?: () => void
}

const optimizedImages = [
  { mimeType: 'image/avif', suffixes: ['___optimized_300.avif', '___optimized_600.avif 3x'] },
  { mimeType: 'image/webp', suffixes: ['___optimized_300.webp', '___optimized_600.webp 3x'] },
  { mimeType: 'image/jpeg', suffixes: ['___optimized_300.jpg', '___optimized_600.jpg 3x'] },
]

function getImageBasePath(inputPath: string) {
  const inputFileName = inputPath.replace('.jpg', '').replace('.png', '')
  if (inputFileName.includes('/release/')) {
    // e-gaming games
    const outputFileName = inputFileName
      .replace('/release/', '/e-gaming/')
      .replace(/\/e-gaming\/([a-z0-9]+).*(site-[a-z]+)/i, '/e-gaming/$1-$2')

    return outputFileName
  }

  return inputFileName
}

export function Image({ game, forceInView, onClick }: Props) {
  const { ref, inView } = useInView({ triggerOnce: true })
  const { imagePath } = game
  const imageBasePath = getImageBasePath(imagePath)

  return (
    <>
      <Badges game={game} />
      <ImageBox
        ref={ref}
        onClick={onClick}
      >
        {inView || forceInView ? (
          <picture>
            {optimizedImages.map(({ mimeType, suffixes }) => (
              <source
                key={mimeType}
                srcSet={suffixes.map((suffix) => `${imageBasePath}${suffix}`).join(', ')}
                type={mimeType}
              />
            ))}
            <img src={imagePath} />
          </picture>
        ) : null}
      </ImageBox>
    </>
  )
}
